import Crud from '../views/Rota/Crud'
import Entity from '../views/Rota/Add'

let routes = {
    path: '/rotas',
    component: resolve => require(['../layouts/full/LayoutFull'], resolve),
    children: [
        {
            path: '/rotas/add',
            name: 'NewRota',
            component: Entity,
            meta: {
                pageTitle: 'Adicionar rotas ',
                breadcrumb: [
                    {
                        text: 'Rota',
                        active: false,
                        to: '/rotas',
                    },
                    {
                        text: 'criar',
                        active: true,
                    },
                ],
            },
        },
        {
            path: '/rotas/edit/:id?',
            name: 'EditRota',
            component: Entity,
            meta: {
                pageTitle: 'Editar Rota',
                breadcrumb: [
                    {
                        text: 'Rota',
                        active: false,
                        to: '/rotas',
                    },
                    {
                        text: 'editar',
                        active: true,
                    },
                ],
            },
        },
        {
            path: '/rotas',
            name: 'list-rotas',
            component: Crud,
            meta: {
                pageTitle: 'Lista de rotas',
                breadcrumb: [
                    {
                        text: 'rotas',
                        active: true,
                    },
                ],
            },
        },
    ]
};


export default routes
